// KD-3848 — the rooms of a hotel search from the assistant: adults and
// children spread as evenly as the rooms allow, each room with an adult.

/** One room fits a couple or a triple; more people need the TO to say. */
export const MAX_ADULTS_WITHOUT_ROOMS = 3;

/** A first guess for a group: two adults a room. */
export const suggestedRooms = adults => Math.max(1, Math.ceil(adults / 2));

export const splitRooms = (rooms, adults, birthdates) =>
  Array.from({ length: rooms }, (_, room) => {
    const kids = birthdates.filter((_, i) => i % rooms === room);
    return {
      adults: Math.floor(adults / rooms) + (room < adults % rooms ? 1 : 0),
      children: kids.length,
      childrenBirthdates: kids,
    };
  });
